import { apiFetch } from "./http";

export type AppNotification = {
  id: string;
  type: "moderation_published" | "moderation_hidden" | string;
  targetType?: "card" | "post";
  targetId?: string;
  title: string;
  body: string;
  readAt?: string | null;
  createdAt: string;
};

export async function fetchNotifications(token: string) {
  return apiFetch<{ notifications: AppNotification[]; unreadCount: number }>("/api/v1/me/notifications?limit=50", {
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function markNotificationRead(token: string, notificationId: string) {
  return apiFetch<{ ok: true }>(`/api/v1/me/notifications/${encodeURIComponent(notificationId)}/read`, {
    method: "PATCH",
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function markAllNotificationsRead(token: string) {
  return apiFetch<{ ok: true; updated: number }>("/api/v1/me/notifications/read-all", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
}
